import { get } from 'lodash'

export default {
  methods: {
    getValueByPath(path) {
      return get(this.rootValue, path)
    },
    checkCondition(condition) {
      const fieldValue = this.getValueByPath(condition.field)
      switch (condition.operator) {
        case '==':
          return String(fieldValue) === String(condition.value)
        case '!=':
          return String(fieldValue) !== String(condition.value)
        case '>':
          return Number(fieldValue) > Number(condition.value)
        case '>=':
          return Number(fieldValue) >= Number(condition.value)
        case '<':
          return Number(fieldValue) < Number(condition.value)
        case '<=':
          return Number(fieldValue) <= Number(condition.value)
        case '==empty':
          return !fieldValue || fieldValue === '' || (Array.isArray(fieldValue) && !fieldValue.length)
        case '!=empty':
          return fieldValue && fieldValue !== '' && !(Array.isArray(fieldValue) && !fieldValue.length)
        default:
          return true
      }
    },
    matchesDependsOn(dependsOn) {
      if (!dependsOn || !dependsOn.length) {
        return true
      }
      return dependsOn.some(andGroup =>
        andGroup.every(condition => this.checkCondition(condition))
      )
    },
  },
}
